import { Feature } from "ol";
import { LineString } from "ol/geom";
import { Point } from "ol/geom";
import { Filter } from "./enums";
import { getCurrentPosition } from "./useMap";
export interface IFilterOption {
  value: number | string | boolean;
  not?: boolean;
}

export type FilterOptions = {
  [Filter.PLACESUBTYPE]?: IFilterOption[];
  [Filter.VISITED]?: IFilterOption[];
  [Filter.LIKE]?: IFilterOption[];
  [Filter.TOURISMTYPESSTR]?: IFilterOption[];
  [Filter.LVREGION]?: IFilterOption[];
  [Filter.nearby]?: boolean;
};

export const filterFeatures = (
  allFeatures: Feature[],
  filterOptions: FilterOptions
): Feature[] => {
  let filteredFeatures = allFeatures;
  if (filterOptions.PLACESUBTYPE?.length) {
    filteredFeatures = filteredFeatures.filter((f) => {
      const value = f.get("PLACESUBTYPE");
      return filterOptions.PLACESUBTYPE.filter((fo) =>
        Array.isArray(fo.value)
          ? fo.not
            ? !fo.value.includes(value)
            : fo.value.includes(value)
          : fo.not
          ? value !== fo.value
          : value === fo.value
      ).length;
    });
  }
  if (filterOptions.VISITED?.length) {
    filteredFeatures = filteredFeatures.filter((f) => {
      const value = f.get("VISITED");
      return filterOptions.VISITED.filter((fo) =>
        fo.not ? value !== fo.value : value === fo.value
      ).length;
    });
  }
  if (filterOptions.LIKE?.length) {
    filteredFeatures = filteredFeatures.filter((f) => {
      const value = f.get("LIKE");
      return filterOptions.LIKE.filter((fo) =>
        fo.not ? value !== fo.value : value === fo.value
      ).length;
    });
  }
  if (filterOptions.LVREGION?.length) {
    filteredFeatures = filteredFeatures.filter((f) => {
      const value = f.get("LVREGION");
      return filterOptions.LVREGION.filter((fo) =>
        fo.not ? value !== fo.value : value === fo.value
      ).length;
    });
  }
  if (filterOptions.nearby) {
    const location = getCurrentPosition();

    if (location) {
      filteredFeatures = filteredFeatures.filter((feature) => {
        const line = new LineString([
          (feature.getGeometry() as Point).getCoordinates(),
          location,
        ]);
        return line.getLength() < 60000;
      });
    }
  }
  return filteredFeatures;
};
